/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchMyPaymentRequests200ResponseInnerSupplier
 */
export interface SearchMyPaymentRequests200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'accountType': SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'companyName': string;
}

export const SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum = typeof SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum];


